export default __webpack_public_path__ + "static/media/640_portfolio02-it-mobile.e9254193.png";